export const PARENT_TYPES = {
  TOPIC: 'Topics::Topic',
  NETWORK: 'Network',
};
